import { useEffect, useState } from 'react';

const REFRESH_TIMER_MS = 60000; // 1 minute

export const useCurrentDateTimer = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, REFRESH_TIMER_MS);

    return () => clearInterval(interval);
  }, []);

  return date;
};
